module.exports = __webpack_public_path__ + "media/images/country_flags/bi-cd20e1259a426b8b861cff534368323b.png";